/**
 * BattleUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleUpdateReq
 */
export interface BattleUpdateReq {
  /** 对战ID */
  id?: string
  /** 红方战队名称 */
  red_team_name?: string
  /** 蓝方战队名称 */
  blue_team_name?: string
  /** 红方战队头像ID */
  red_team_avatar_id?: string
  /** 蓝方战队头像ID */
  blue_team_avatar_id?: string
}

/**
 * BattleUpdateReq Schema
 */
export const BattleUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '对战ID',
      format: 'string',
      type: 'string',
      label: '对战ID',
    },
    red_team_name: {
      description: '红方战队名称',
      format: '*string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '红方战队名称',
    },
    blue_team_name: {
      description: '蓝方战队名称',
      format: '*string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '蓝方战队名称',
    },
    red_team_avatar_id: {
      description: '红方战队头像ID',
      format: '*string',
      type: 'string',
      label: '红方战队头像ID',
    },
    blue_team_avatar_id: {
      description: '蓝方战队头像ID',
      format: '*string',
      type: 'string',
      label: '蓝方战队头像ID',
    },
  },
  type: 'object',
}
